function HeroSection({ onRegisterClick, registrationContent, trustLogos = [] }) {
  return (
    <section className="hero section">
      <div className="container hero-grid">
        <div className="hero-main">
          <h1>Monthly AI Lab for School Leaders</h1>
          <p className="hero-copy">
            A free, monthly 60-minute AI Lab for principals and superintendents.
            Each session walks through 4-5 concrete ways school leaders use AI to
            save hours on email, reports, and staff support while making better
            decisions.
          </p>

          <ul className="hero-checklist" aria-label="AI Lab benefits">
            <li>Free for school leaders</li>
            <li>Register once</li>
            <li>Zoom link and calendar invite included</li>
            <li>Recording included each month</li>
          </ul>

          <button
            className="btn btn-primary hero-mobile-register-btn"
            type="button"
            onClick={onRegisterClick}
          >
            Register free in under 15 seconds
          </button>

          {/* <div className="hero-trust-inline">
            <p>Trusted by principal associations in MN, MO, OH, MT, and more.</p>
            <div className="hero-trust-logos">
              {trustLogos.slice(0, 5).map((logoItem) => {
                const key = logoItem.id || logoItem.name;
                const image = <img src={logoItem.logo} alt={logoItem.name} />;

                if (logoItem.website) {
                  return (
                    <a
                      key={key}
                      className="hero-trust-logo-item"
                      href={logoItem.website}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={logoItem.name}
                    >
                      {image}
                    </a>
                  );
                }

                return (
                  <span key={key} className="hero-trust-logo-item" aria-label={logoItem.name}>
                    {image}
                  </span>
                );
              })}
            </div>
          </div> */}
        </div>

        {registrationContent ? (
          <aside className="hero-form-panel">{registrationContent}</aside>
        ) : null}
      </div>
    </section>
  );
}

export default HeroSection;
